import React, { useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { InputWithLabel } from "../../components/micro/input";
import LoginIcon from "../../assets/image/logo.png";
import { forgetPassword } from "../../redux/auth/slice";

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <>
      <div className={`h-screen overflow-hidden relative`}>
        <div className={`flex items-center justify-center h-full`}>
          <section className="w-full">
            <div className="max-w-xl w-full mx-auto">
              <div className="flex justify-center mb-4">
                <img src={LoginIcon} alt="logo" className="object-cover w-40" />
              </div>
              <div className="rounded-lg drop-shadow-lg bg-white px-6 py-8 mx-4 border border-gray shadow-lg">
                <div className={"mb-8"}>
                  <h5 className="sm:text-2xl text-2xl text-primaryBlack font-Montserrat font-normal mb-1">
                    Reset Password
                  </h5>
                  <p className="text-sm text-textSecondary font-normal font-Proxima">
                    We will send you a link to reset
                  </p>
                  <p className="text-sm text-textSecondary font-normal font-Proxima">
                    your password via email
                  </p>
                </div>
                <Formik
                  initialValues={{
                    email: "",
                    role: "admin",
                  }}
                  validationSchema={Yup.object({
                    email: Yup.string().required("Please enter email"),
                  })}
                  onSubmit={(values) => {
                    setLoading(true);
                    dispatch(forgetPassword(values)).then((res) => {
                      setLoading(false);
                      if (res.type === "forgetPassword/fulfilled") {
                        navigate("/login");
                      }
                    });
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="space-y-5">
                        {/* Email */}
                        <InputWithLabel
                          className={`border border-gray ${
                            errors.email && touched.email
                              ? "border-red"
                              : values.email
                              ? "border-themeBtn"
                              : ""
                          }`}
                          idFromName="email"
                          label="Email"
                          type="email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          errors={errors.email && touched.email}
                          errorsText={errors.email}
                          labelClass="bg-white"
                        />
                        <button
                          type="submit"
                          className="w-full block text-bgWhite font-normal bg-themeBtn text-center text-[15px] border-2 border-transparent uppercase hover:bg-transparent hover:border-2 hover:border-themeBtn hover:text-themeBtn rounded transition duration-500 py-2 lg:px-7 px-4"
                        >
                          {loading ? "loading...." : "Send me the reset link"}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
